import { render, staticRenderFns } from "./addQuestionInterView.vue?vue&type=template&id=4edece11&scoped=true&"
import script from "./addQuestionInterView.vue?vue&type=script&lang=js&"
export * from "./addQuestionInterView.vue?vue&type=script&lang=js&"
import style0 from "./addQuestionInterView.vue?vue&type=style&index=0&id=4edece11&prod&lang=scss&scoped=true&"
import style1 from "./addQuestionInterView.vue?vue&type=style&index=1&id=4edece11&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edece11",
  null
  
)

export default component.exports